export default __webpack_public_path__ + "static/media/Saints.389f63a6.png";